import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})

export class GrnService {
    private accountingUrl = environment.accountingUrl;

    constructor(private http: HttpClient, private cookieService: CookieService) {}

    getGrnTemplates(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grn-form-templates/`;
        return this.http.get<any>(url, { withCredentials: true });
    }


    getDefaultGrnFormTemplate(): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grn-form-templates/default`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getFormTemplateById(Id: string): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grn-form-templates/${Id}`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    saveGrn(payload: any): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/`;
        return this.http.post<any>(url, payload, { withCredentials: true });
    }

    updateGrn(grnId: string | number, payload: any): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/${grnId}`;
        return this.http.put<any>(url, payload, { withCredentials: true });
    }

    getGrns(params?: any, excludeBilled: boolean = true): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/`;
        const queryParams = new URLSearchParams();

        if (params) {
            if (params.limit) queryParams.append('limit', params.limit.toString());
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.vendor_id) queryParams.append('vendor_id', params.vendor_id);
            if (params.pi_number) queryParams.append('pi_number', params.pi_number);
            if (params.po_number) queryParams.append('po_number', params.po_number);
            if (params.grn_number) queryParams.append('grn_number', params.grn_number);
            if (params.accounting_status) queryParams.append('accounting_status', params.accounting_status);
            if (params.approval_status) queryParams.append('approval_status', params.approval_status);
            if (params.created_date) queryParams.append('created_date', params.created_date);
            if (params.grn_date) queryParams.append('grn_date', params.grn_date);
            if (params.from_date) queryParams.append('from_date', params.from_date);
            if (params.to_date) queryParams.append('to_date', params.to_date);
            if (params.get_references) queryParams.append('get_references', params.get_references);
            if (params.for_asset) queryParams.append('for_asset', params.for_asset.toString());
        }

        // Add exclude_billed parameter
        queryParams.append('exclude_billed', excludeBilled.toString());

        const finalUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;
        return this.http.get<any>(finalUrl, { withCredentials: true });
    }

    cancelGrn(grnId: string | number): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/${grnId}/cancel`;
        return this.http.patch<any>(url, {}, { withCredentials: true });
    }

    deleteGrn(grnId: string | number): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/${grnId}`;
        return this.http.delete<any>(url, { withCredentials: true });
    }

    getGrnById(grnId: string | number, params?: any): Observable<any> {
        let url = `${this.accountingUrl}/api/v1/grns/${grnId}`;
        
        if (params) {
            const queryParams = new URLSearchParams();
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined) {
                    queryParams.append(key, params[key]);
                }
            });
            const queryString = queryParams.toString();
            if (queryString) {
                url += `?${queryString}`;
            }
        }
        
        return this.http.get<any>(url, { withCredentials: true });
    }

    getGrnByPiId(piId: string | number): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/by-pi-id/${piId}`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getPurchaseInvoiceById(invoiceId: string): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-invoices/${invoiceId}`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getPurchaseInvoiceByVendor(vendorId: string): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/vendor-invoices/?type=all&offset=0&limit=50&vendor_id=${vendorId}&is_cancelled=false`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    getAuditLogs(grnId: string | number, params?: any): Observable<any> {
        let url = `${this.accountingUrl}/api/v1/grns/${grnId}/audit-logs`;

        if (params) {
            const queryParams = new URLSearchParams();
            Object.keys(params).forEach(key => {
                if (params[key] !== null && params[key] !== undefined) {
                    queryParams.append(key, params[key]);
                }
            });
            const queryString = queryParams.toString();
            if (queryString) {
                url += `?${queryString}`;
            }
        }

        return this.http.get<any>(url, { withCredentials: true });
    }

    /**
     * Get print data for a GRN (for PDF generation)
     * Endpoint: GET /api/v1/grns/:id/print-data
     */
    getPrintData(grnId: string | number): Observable<any> {
        const url = `${this.accountingUrl}/api/v1/grns/${grnId}/print-data`;
        return this.http.get<any>(url, { withCredentials: true });
    }

}